import React from 'react';
import ReactCountryFlag from 'react-country-flag';
import countries from 'i18n-iso-countries';

// Import language registrations
countries.registerLocale(require('i18n-iso-countries/langs/en.json'));
countries.registerLocale(require('i18n-iso-countries/langs/es.json'));
countries.registerLocale(require('i18n-iso-countries/langs/fr.json'));
countries.registerLocale(require('i18n-iso-countries/langs/de.json'));
countries.registerLocale(require('i18n-iso-countries/langs/it.json'));
countries.registerLocale(require('i18n-iso-countries/langs/pt.json'));
countries.registerLocale(require('i18n-iso-countries/langs/ru.json'));
countries.registerLocale(require('i18n-iso-countries/langs/zh.json'));
countries.registerLocale(require('i18n-iso-countries/langs/ja.json'));

/**
 * Get country name from country code in the specified language
 * @param {string} countryCode - ISO country code (e.g., 'US', 'GB')
 * @param {string} language - Language code (e.g., 'en', 'es', default: 'en')
 * @returns {string} - Country name or country code if not found
 */
const getCountryName = (countryCode, language = 'en') => {
  if (!countryCode) return '';
  
  try {
    // Convert to uppercase to ensure proper format
    const code = countryCode.toUpperCase();
    const name = countries.getName(code, language);
    return name || countryCode; // Return code as fallback if name not found
  } catch (error) {
    console.warn(`Error getting country name for code: ${countryCode}`, error);
    return countryCode;
  }
};

/**
 * A utility component for displaying country flags consistently across the application
 * @param {Object} props - Component props
 * @param {string} props.countryCode - ISO country code (e.g., 'US', 'GB')
 * @param {Object} props.style - Optional additional styles to apply
 * @param {string} props.language - Optional language code for country name (default: 'en')
 * @returns {React.Component} - Country flag component
 */
const CountryFlag = ({ countryCode, style = {}, language = 'en' }) => {
  if (!countryCode) return null;
  
  const defaultStyle = {
    width: '1.2em',
    height: '1.2em',
    marginLeft: '8px',
    verticalAlign: 'middle',
  };

  // Get country name for tooltip
  const countryName = getCountryName(countryCode, language);
  const tooltipText = countryName !== countryCode ? `${countryName}` : countryCode;
  
  return (
    <ReactCountryFlag
      countryCode={countryCode}
      svg
      style={{ ...defaultStyle, ...style }}
      title={tooltipText}
    />
  );
};

export default CountryFlag;
